import axios from 'axios';
import Cookie from 'js-cookie';

// Use localhost for browser (client-side), host.docker.internal for server-side (inside container)
const getBaseURL = () => {
  if (typeof window !== 'undefined') {
    // Client-side: use localhost
    return process.env.API_URL;
  }
  // Server-side (inside Docker): use host.docker.internal
  return process.env.API_URL.replace('localhost', 'host.docker.internal');
};

export const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true
});

axiosInstance.interceptors.request.use(async config => {
  if (typeof window !== 'undefined') {
    const jwt = Cookie.get('jwt');

    if (jwt) {
      config.headers['X-Access-Token'] = jwt;
    }

    return config;
  }

  return config;
}, err => Promise.reject(err));

axiosInstance.interceptors.response.use(
  response => response,
  error => Promise.reject(error.response.data)
);
